import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Persistent status bar shown at the top of a platform's trial funnel once
 * its TRIAL_POC window has closed (`now > pocEndDate`). Unlike TrialModeBanner
 * this is not dismissible — it reflects a hard restriction (all actions in
 * this section are disabled), not just an informational note.
 */
export function TrialExpiredBanner() {
  const { t } = useTranslation('trial');

  return (
    <div
      className="bg-accent-100 text-accent-main flex items-center gap-2 px-4 py-2 text-sm"
      data-testid="trial-expired-banner"
    >
      <Info className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        <span className="font-semibold">{t('expiredBanner.title')}</span>
        <span className="text-foreground"> — {t('expiredBanner.message')}</span>
      </span>
    </div>
  );
}
